<template>
  <div class="container">
    <div class="title">
      <div class="title_left" @click="showTimePicker">
        <span>{{city}}</span>
        <img src="../../../../assets/image/xiala.png" />
      </div>
      <div class="search">
        <div class="search_key" @click="goSearch">退货单号/退货商家/退货人姓名</div>
        <img src="../../../../assets/image/search.png" class="search_img" />
      </div>
    </div>
    <div class="attention" @click="goAttention">
        <span>我的关注</span>
        <i></i>
    </div>
    <div class="title_text">实时数据</div>
    <div class="check_list">
      <div class="item">
        <div class="box">
          <div class="select_type line_bottom">
            <span
              class="t_txt1"
              v-for="(item,index) in dataList"
              :key="index"
              :class="{'t_active':item.select,'t_left':index===0,'t_right':index===3}"
              @click="selectAll(index,item)"
            >{{item.key}}</span>
          </div>
          <div class="left line_right line_bottom line" @click="goLeader('')">
            <p class="status">退货申请(起)</p>
            <div class="num">{{homeInfo.allReturnList}}</div>
            <span class="total1_price">{{homeInfo.totalShoppingAmount|filt}}<i v-if="parseInt(homeInfo.totalShoppingAmount)<10000">元</i><i v-if="parseInt(homeInfo.totalShoppingAmount)>=10000&&parseInt(homeInfo.totalShoppingAmount)<100000000">万元</i>
                           <i v-if="parseInt(homeInfo.totalShoppingAmount)>=100000000">亿元</i></span>
          </div>
          <div class="left  line_bottom" @click="goLeader('processing')">
            <p class="status">处理中(起)</p>
            <div class="num">{{homeInfo.waitHandle}}</div>
            <span class="total1_price">{{homeInfo.waitHandleShoppingAmount|filt}}<i v-if="parseInt(homeInfo.waitHandleShoppingAmount)<10000">元</i><i v-if="parseInt(homeInfo.waitHandleShoppingAmount)>=10000&&parseInt(homeInfo.waitHandleShoppingAmount)<100000000">万元</i>
                           <i v-if="parseInt(homeInfo.waitHandleShoppingAmount)>=100000000">亿元</i></span>
          </div>
          <div class="left line_right line_bottom" @click="goLeader('refundSuccess')">
            <p class="status">退货成功(起)</p>
            <div class="num">{{homeInfo.refundSuccess}}</div>
            <span class="total1_price">{{homeInfo.refundSuccessRefundAmount|filt}}<i v-if="parseInt(homeInfo.refundSuccessRefundAmount)<10000">元</i><i v-if="parseInt(homeInfo.refundSuccessRefundAmount)>=10000&&parseInt(homeInfo.refundSuccessRefundAmount)<100000000">万元</i>
                           <i v-if="parseInt(homeInfo.refundSuccessRefundAmount)>=100000000">亿元</i></span>
          </div>
          <div class="left  line_bottom" @click="goLeader('waitAccept')">
            <p class="status">待受理(起)</p>
            <div class="num">{{homeInfo.waitAccept}}</div>
            <span class="total1_price">{{homeInfo.waitAcceptShoppingAmount|filt}}<i v-if="parseInt(homeInfo.waitAcceptShoppingAmount)<10000">元</i><i v-if="parseInt(homeInfo.waitAcceptShoppingAmount)>=10000&&parseInt(homeInfo.waitAcceptShoppingAmount)<100000000">万元</i>
                           <i v-if="parseInt(homeInfo.waitAcceptShoppingAmount)>=100000000">亿元</i></span>
          </div>
          <div class="left line line_right" @click="goLeader('userRevoke')">
            <p class="status">游客撤销(起)</p>
            <div class="num">{{homeInfo.userRevoke}}</div>
            <span class="total1_price">{{homeInfo.userRevokeShoppingAmount|filt}}<i v-if="parseInt(homeInfo.userRevokeShoppingAmount)<10000">元</i><i v-if="parseInt(homeInfo.userRevokeShoppingAmount)>=10000&&parseInt(homeInfo.userRevokeShoppingAmount)<100000000">万元</i>
                           <i v-if="parseInt(homeInfo.userRevokeShoppingAmount)>=100000000">亿元</i></span>
          </div>
          <div class="left" @click="goLeader('refuseAccept')">
            <p class="status">不予受理(起)</p>
            <div class="num">{{homeInfo.refuseAccept}}</div>
            <span class="total1_price">{{homeInfo.refuseAcceptShoppingAmount|filt}}<i v-if="parseInt(homeInfo.refuseAcceptShoppingAmount)<10000">元</i><i v-if="parseInt(homeInfo.refuseAcceptShoppingAmount)>=10000&&parseInt(homeInfo.refuseAcceptShoppingAmount)<100000000">万元</i>
                           <i v-if="parseInt(homeInfo.refuseAcceptShoppingAmount)>=100000000">亿元</i></span>
          </div>
          <div class="t_txt" v-if="false">数据可视化</div>
        </div>
      </div>
    </div>
    <div class="day_info">近30天退货同比趋势</div>
    <div class="line-contain">
      <!-- <lineCharts :data="lineList" :color="color" :showYear="true" unit="起"/> -->
      <lineChartsTwo :data="lineList" v-if="lineList.length" :dataTitle="lineListTitle" :color="color" :showYear="true" unit="起"/>
    </div>

    <div class="day_info">退货商品类型分布情况</div>
    <div class="line-contain">
      <medicinePieCharts :pieData="medicinePieList" :color="colorList" :ShowText="isShowText"/>
    </div>
    <div class="day_info"> </div>

    <time-picker ref="timePicker" :minDate="minDate"></time-picker>
    <common-picker
      ref="commonPicker"
      :typeList="typeList"
      :cols="cols"
      @getTypeValue="getCityValue"
    ></common-picker>
    <!-- 关注入口 -->
    <!-- <img src="../../../../assets/image/attention.png" class="attention" @click="goAttention"/> -->
  </div>
</template>
<script>
    import api from '../../../../service/modules/refund';
    import moment from 'moment';
    import util from '../../../../utils/common';
    import lineChartsTwo from '../../../../components/LineChartsTwo';
    import medicinePieCharts from "@/components/MedicinePieCharts";
    import timePicker from '../../../../components/base/timePick';
    import commonPicker from '../../../../components/base/commonPicker';
    import { timeType } from '../../../../utils/configJson';
    export default {
        components: {
            'time-picker': timePicker,
            'common-picker': commonPicker,
            lineChartsTwo,
            medicinePieCharts
        },
        data () {
            return {
                checked: false,
                typeList: timeType,
                minDate: new Date(2018, 1, 1),
                isPickerShow1: false,
                cols: 2,
                selectCode: '',
                city: '',
                citycode: '',
                cityName: '',
                lineChart: null,
                aboutTime: 'today',
                dataList: [
                    { key: '今日', select: true, value: 'today' },
                    { key: '本周', select: false, value: 'week' },
                    { key: '本月', select: false, value: 'mouth' },
                    { key: '全部', select: false, value: 'all' }
                ],
                distantce: 0,
                chartList: [],
                homeInfo: '',
                startTime: moment(new Date().getTime()).format('YYYY-MM-DD'),
                endTime: moment(new Date().getTime()).format('YYYY-MM-DD'),
                refundType: '',
                cityList: '',
                info: '',
                // 折线图
                lineList: [

                ],
                lineListTitle: [],
                color: 'green',
                medicinePieList: [],
                colorList: ['#A0A7E5', '#69E5C1', '#626B90', "#C3EAAD", "#40B0E2"],
                isShowText: true
            };
        },
        mounted () {
            // this.$store.commit('complaint/setBackDetail', '');
            this.getNoticeNum()
        },
        created () {
            this.getInitTime(this.startTime, this.endTime);
            this.getUser();
            this.getType();
        },
        methods: {
            /**
             *    退货商品类型分布情况
             */
            getShoppingType () {
              api.classified().then(res => {
                if (res.ret === 0) {
                  this.medicinePieList = res.data.map(item => {
                    return {
                      name: item.productTypeText,
                      type: item.type,
                      count: item.count,
                      productType: item.productType,
                      value: item.value
                    }
                  })
                }
              })
            },

            // 拉取待办数量
            getNoticeNum () {
                this.$store.dispatch('notice/getRefundNum')
            },
            getType () {
                // 获取配置中心数据
                api.typePicker({}).then(res => {
                    if (res.ret === 0) {
                        // this.$store.state.configlist = res.data;
                        util.setJsonLocal('configList', res.data);
                    }
                });
            },
            getAllCity (citycode) {
                // 获取所有的市
                api.getCity({ regionCode: citycode }).then(res => {
                    var list = res.data[0];
                    let city = [];
                    if (list.regionType === 1) {
                        // 多个市
                        if (list.children != null) {
                            this.cols = 2;
                            var obj = {
                                value: list.code,
                                label: list.name,
                                children: [{ value: '530000', label: '全部', children: [] }]
                            };
                            list.children.map((item, index) => {
                                obj.children.push({
                                    value: item.code,
                                    label: item.name,
                                    children: []
                                });
                            });
                            city.push(obj);
                        } else {
                            city.push({ value: list.code, label: list.name, children: [] });
                            this.cols = 1;
                        }
                    } else {
                        // 一个市
                        if (list.children != null) {
                            this.cols = 2;
                            var obj = {
                                value: list.code,
                                label: list.name,
                                children: [{ value: list.code, label: '全部', children: [] }]
                            };
                            list.children.map((item, index) => {
                                obj.children.push({
                                    value: item.code,
                                    label: item.name,
                                    children: []
                                });
                            });
                            city.push(obj);
                        } else {
                            city.push({ value: list.code, label: list.name, children: [] });
                            this.cols = 1;
                        }
                    }
                    this.typeList = [];
                    this.typeList.push(city);
                    setTimeout(() => {
                        this.$refs.commonPicker._initFresh();
                    }, 50);
                });
            },
            showTimePicker () {
                // this.$refs.timePicker.showPicker();
                this.$refs.commonPicker.showPicker();
            },
            getInitTime (startTime, endTime) {
                // 获取初始化时间
                this.$store.commit('refund/getStartTime', startTime);
                this.$store.commit('refund/getEndTime', endTime);
            },
            getUser () {
                // 获取用户信息
                api.currentUser().then(res => {
                    if (res.ret === 0) {
                        this.$store.commit('refund/getUserInfo', res.data);
                        this.info = res.data;
                        this.city = res.data.regionName;
                        this.citycode = res.data.regionCode;
                        this.selectCode = res.data.regionCode;
                        this.cityName = res.data.regionName;
                        this.getInfoList();
                        this.getAllCity(this.citycode);
                        //  setConfiglist
                        this.getLate();
                        this.getShoppingType();
                        // this.getType()
                    } else {
                    }
                });
            },
            // 获取所选择的regioncode
            getCityValue (value) {
                if (value[1].label == '全部') {
                    this.city = '云南省';
                } else {
                    this.city = value[1].label;
                }
                this.citycode = value[1].value;
                this.getInfoList();
                this.getLate();
            },
            goLeader (value) {
                this.$router.push(
                    '/refund/leaderList?citycode=' +
                        this.citycode +
                        '&aboutTime=' +
                        this.aboutTime +
                        '&refundType=' +
                        value +
                        '&cityName=' +
                        encodeURI(this.city)
                );
            },
            goSearch () {
                this.$router.push('/refund/search?citycode=' + this.citycode);
            },
            goAttention () {
                this.$router.push('/refund/leaderAttention?citycode' + this.citycode);
            },
            selectAll (index, item) {
                this.dataList.map((item, index1) => {
                    this.$set(this.dataList[index1], 'select', false);
                });
                this.$set(this.dataList[index], 'select', true);
                this.aboutTime = item.value;
                if (item.value === 'today') {
                    this.startTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                } else if (item.value === 'week') {
                    let nowTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    var data = util.getWeekStartEnd(moment, nowTime);
                    this.startTime = data.start;
                    this.endTime = data.end;
                } else if (item.value === 'mouth') {
                    var currentDateMon = new Date();
                    // 获取当前月的第一天
                    this.startTime = this.getCurrentMonthFirst(currentDateMon);
                    // 获取当前月的最后一天
                    this.endTime = this.getCurrentMonthLast(currentDateMon);
                } else if (item.value === 'all') {
                    this.startTime = '2019-05-01';
                    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                }
                // this.$store.state.startTime = this.startTime
                // this.$store.state.endTime = this.endTime
                this.getInfoList();
                this.getInitTime(this.startTime, this.endTime);
            },
            getCurrentMonthFirst (d) {
                var date = new Date(d);
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            getCurrentMonthLast (d) {
                var date = new Date(d);
                var currentMonth = date.getMonth();
                var nextMonth = ++currentMonth;
                var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                var oneDay = 1000 * 60 * 60 * 24;
                var lastTime = new Date(nextMonthFirstDay - oneDay);
                var month = parseInt(lastTime.getMonth() + 1);
                var day = lastTime.getDate();
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            getInfoList () {
                api
                    .workbenchLeader({
                        areaId: this.citycode,
                        startDate: this.startTime,
                        endDate: this.endTime
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.homeInfo = res.data;
                        }
                    });
            },
            getLate () { // 近30天退货趋势数据
                // api.lately30({ areaId: this.citycode }).then(res => {
                //     if (res.ret === 0) {
                //         this.lineList = [];
                //         res.data.map(item => {
                //             let obj = { xAxis: item.date.substring(5, 10), num: item.count }
                //             this.lineList.push(obj);
                //         })
                //     }
                // });
                api.visualTrend({ dateType: 4, cover: 1, startDate: util.startdateDay().startdate, endDate: util.startdateDay().enddate }).then(res => {
                  if (res.ret === 0) {
                    this.lineList = [];
                    let dataOne = [];
                    let dataTwo = [];
                    let data = res.data.reverse();
                    for (let i = 0; i < data.length; i++) {
                      if (i % 2 == 0) {
                        dataOne.push(data[i].applyNumValue);
                        this.lineListTitle.push(data[i].date.substring(5, 10))
                      } else {
                        dataTwo.push(data[i].applyNumValue);
                      }
                    }
                    this.lineList = [
                      {
                        name: '申请数量',
                        type: 'line',
                        stack: '总量',
                        data: dataOne
                        // data: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                      },
                      {
                        name: '申请数量',
                        type: 'line',
                        stack: '总量',
                        data: dataTwo
                        // data: [9,8,7,6,5,4,3,2,1,0,9,8,7,6,5,4,3,2,1,0,9,8,7,6,5,4,3,2,1,9,8]
                      }
                    ]
                  }
                })
            },
            getType () {
                // 获取配置中心数据
                api.typePicker({}).then(res => {
                    if (res.ret === 0) {
                        this.$store.commit('refund/setConfiglist', res.data);
                        util.setJsonLocal('configList', res.data);
                    }
                });
            }
        },
        beforeRouteLeave (to, from, next) {
            if (to.path === '/refund/leaderList') {
                to.meta.title = this.city + '数据统计'
            }
            next()
        },
        filters: {
            filt (value) {
                if (parseInt(value) < 10000) {
                    return value
                } else if (parseInt(value) >= 10000 && parseInt(value) < 100000000) {
                    return (parseFloat((value) / 10000).toFixed(2))
                } else if (parseInt(value) >= 100000000) {
                    return (parseFloat((value) / 100000000).toFixed(2))
                }
            }
        }
    };
</script>
<style scoped lang="less">
.container {
  width: 100%;
  background-color: #fbfbfb;
  // padding-bottom: 20px;
  .title {
    width: 100%;
    padding: 12px 16px;
    // height:60px;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    // padding-bottom: 12px;
    .title_left {
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      span {
        width: 46px;
        font-size: 14px;
        line-height: 16px;
        color: #4a4a4a;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      img {
        width: 6px;
        height: 4px;
        margin-left: 0px;
      }
    }
    .search {
      width: 100%;
      position: relative;
      .search_key {
        // width: 276px;
        height: 36px;
        margin-left: 15px;
        border: 1px solid #eeeeee;
        padding-left: 39px;
        box-sizing: border-box;
        outline: none;
        line-height: 36px;
        color: #9b9b9b;
        font-size: 14px;
        border-radius: 3px;
      }
      .search_img {
        width: 15px;
        height: 14px;
        position: absolute;
        left: 30px;
        top: 11px;
      }
    }
  }
  .title_text {
    background-color: #fafafa;
    width: 100%;
    margin-bottom: 12px;
    padding-left: 16px;
    font-size: 20px;
    color: #333;
    font-weight: bold;
  }
  .check_list {
    margin: 0 12px;
    margin-right: 12px;
    box-sizing: border-box;
    background-color: #ffffff;
    .item {
      width: 100%;
      .box {
        width: 100%;
        box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        font-size: 0;
        padding-top:24px;
        .select_type {
          width:100%;
          padding:0 20px 30px 20px;
          box-sizing: border-box;
          background: #ffffff;
          // border-bottom: 1px solid #efefef;
          .t_txt1 {
            width: 24.4%;
            // height: 32px;
            padding:8px 0px;
            display: inline-block;
            // line-height: 32px;
            text-align: center;
            border: 1px solid  #36B374;
            border-right: none;
            font-size: 14px;
            color: #36B374;
          }
          .t_txt:last-child {
              border: 1px solid #36B374;
            }
          .t_active {
            background-color: #36b374;
            color: #fff;
            font-size:14px;
            font-weight: 700;
          }
          .t_left {
            border-radius: 2px 0 0 2px;
            // border: 1px solid  #36B374;
          }
          .t_right {
            border-radius: 0 2px 2px 0;
            border: 1px solid  #36B374;
          }
        }
        .totalPrice{
          width:100%;
          padding:0 12px 24px 12px;
          box-sizing: border-box;
          border-bottom: 1px solid #efefef;
          .aply_price{
            padding-top:27px;
            width:100%;
            display: flex;
            align-items: center;
            span{
              font-size:15px;
              color:#333333;
            }
          }
          .success_total{
            width:100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top:30px;
            .p_text{
              font-size:14px;
              color:#333333;
            }
            .t_total{
              span:nth-child(1){
                font-size:28px;
                color:@base-color;
                font-weight: 700;
              }
              span:nth-child(2){
                font-size:13px;
                color:#333;
              }
            }
          }
          .p_price1{
            width:100%;
            display: flex;
            justify-content: space-between;
            background-color:#F8F8F8;
            height:36px;
            align-items: center;
            margin-top:12px;
            .p_left{
              height:36px;
              line-height: 36px;
              span:nth-child(1){
                font-size:13px;
                color:#666;
              }
              span:nth-child(2){
                font-size:14px;
                color:#666;
              }
            }
            .right{
              height:36px;
            }
          }
        }
        .left {
          width: 50%;
          // height: 100px;
          padding-bottom: 20px;
          display: inline-block;
          text-align: center;
          font-size:0;
          .num {
            margin-top: 8px;
            font-size: 24px;
            color: @base-color;
            // display: inline-block;
            vertical-align: bottom;
            font-weight: 700;
            // font-size: DIN bold;
          }
          .status {
            font-size: 12px;
            margin-top: 24px;
            color: #7d7d7d;
          }
          .total1_price{
            display: inline-block;
            font-size:12px;
            color: #7d7d7d;
            background-color:#F8F8F8;
            margin-top:6px;
            // padding:8px 12px;
            padding:8px 12px 6px 12px;
            border-radius: 3px;
          }
        }
        .t_txt {
          width: 100%;
          height: 70px;
          text-align: center;
          line-height: 70px;
          font-size: 14px;
          color: #7c7c7c;
          border-top: 1px solid #efefef;
        }
        .box_foot {
          overflow: hidden;
          border-top: 1px solid #eeeeee;
          height: 52px;
          width: 100%;
          color: #9b9b9b;
          line-height: 52px;
          text-align: center;
          font-size: 12px;
        }
      }
      .price {
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        justify-content: space-between;
        .p_item {
          // text-align: center;
          margin-top: 30px;
          .money {
            font-size: 25px;
            color: #1890ff;
            font-weight: 700;
          }
          .about_statu {
            font-size: 12px;
            color: #7d7d7d;
            margin-top: 15px;
          }
        }
      }
      .total {
        font-size: 16px;
        color: #2a2a2a;
        margin-top: 50px;
      }
      .item_price {
        width: 100%;
        .get_price {
          // text-align: center;
          margin-left: 80px;
          span:nth-child(1) {
            display: inline-block;
            width: 10px;
            height: 10px;
            vertical-align: middle;
            background-color: #50aeff;
          }
          span:nth-child(2) {
            display: inline-block;
            font-size: 13px;
            color: #7d7d7d;
            vertical-align: middle;
          }
        }
        .success_price {
          margin-top: 15px;
        }
      }
      .other_price {
        margin-top: 50px;
      }
      .fail_price {
        width: 100%;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #efefef;
        span {
          font-size: 14px;
          color: #4a4a4a;
        }
        span:nth-child(1) {
          float: left;
        }
        span:nth-child(2) {
          float: right;
        }
      }
      .day_info {
        font-size: 16px;
        color: #2a2a2a;
        margin-top: 50px;
      }
    }
  }
  .leader_map {
    text-align: center;
    margin-top: 40px;
    span {
      display: inline-block;
      font-size: 14px;
      color: #7d7d7d;
      vertical-align: middle;
    }
    .right_arrow {
      display: inline-block;
      width: 7px;
      height: 12px;
      vertical-align: middle;
    }
  }

  .go_home {
    position: fixed;
    right: 0;
    top: 538px;
    width: 59px;
    height: 59px;
    background-color: #e4f5ff;
    padding: 9px 10px 9px 9px;
    border-radius: 29px 0 0 29px;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .day_info {
    font-size: 20px;
    color: #333333;
    // line-height: 44px;
    padding-top: 24px;
    padding-left: 12px;
    font-weight: bold;
  }
  .attention{

    height: 46px;
    width: 94.2%;
    padding: 0 16px;
    margin: 24px auto;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 15px 0px rgba(0,0,0,0.06);
    border-radius:3px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span{
        font-size:14px;
        font-weight:400;
        color:rgba(2,2,2,1);
        display: inline-block;
        font-family:"PingFangSC-Regular,PingFang SC";
        &::before{
          content:"";
          display: inline-block;
          height:18px;
          width: 18px;
          overflow: hidden;
          margin-right: 10px;
          margin-top:-3px;
          background-image: url("~@/assets/refund/Star@3x.png");
          background-size: 100% 100%;
          position: relative;
          top: 2px;
        }
    }
    i{
       display: inline-block;
       width: 12px;
       height: 12px;
       background-image: url("~@/assets/refund/ic_jt_ck@2x.png");
       background-size: 100% 100%;
    }
  }
}
.line-contain {
  height: 234px;
  margin: 10px 12px 24px 12px;
  background-color: #ffffff;
  box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
}
</style>
